import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/site";
import { useLang, loc } from "../data/i18n";

export default function Testimonials() {
    const { t, lang, isEn } = useLang();
    return (
        <section
            className="relative bg-cream py-24 md:py-32 paper-grain"
            data-testid="testimonials-section"
        >
            <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
                <div className="mb-16">
                    <p className="text-[11px] uppercase tracking-[0.3em] text-coral font-bold mb-5 flex items-center gap-3">
                        <span className="inline-block w-8 h-px bg-coral" />
                        {t.testimonials.kicker}
                    </p>
                    <h2 className="font-serif font-normal text-ocean text-5xl md:text-7xl leading-[0.95] tracking-tight max-w-3xl">
                        <em className="coral-italic">{t.testimonials.titleA}</em>
                        {t.testimonials.titleB}
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {TESTIMONIALS.map((raw, i) => {
                        const item = loc(raw, lang);
                        return (
                            <motion.figure
                                key={item.name}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.7, delay: i * 0.1 }}
                                className="bg-white border border-ocean/10 p-8 md:p-10 flex flex-col justify-between min-h-[340px] shadow-[0_10px_40px_rgba(15,42,63,0.05)]"
                                data-testid={`testimonial-${i}`}
                            >
                                <Quote
                                    size={32}
                                    className="text-coral mb-6"
                                    strokeWidth={1.5}
                                />
                                <blockquote className="font-serif text-ink text-xl md:text-2xl leading-snug mb-8">
                                    {isEn
                                        ? `“${item.text}”`
                                        : `« ${item.text} »`}
                                </blockquote>
                                <figcaption>
                                    <p className="text-ocean text-sm font-semibold">
                                        {item.name}
                                    </p>
                                    <p className="text-coral text-xs uppercase tracking-[0.2em] font-bold mt-1">
                                        {item.role}
                                    </p>
                                </figcaption>
                            </motion.figure>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
